module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/thumbs/3-0a3d72773d604b2546008960c76cbdb1.webp";